import { GoalCard } from "../goals/GoalCard";
import { motion } from "framer-motion";

const GoalsGrid = ({ goals, onGoalClick, isEmpty, t }) => {
    // Animation variants for container
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    // Animation variants for individual items
    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                type: "spring",
                damping: 15,
                stiffness: 100
            }
        }
    };

    return (
        <motion.div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
        >
            {goals.map((goal, index) => (
                <motion.div
                    key={goal._id}
                    variants={itemVariants}
                    custom={index}
                    layout
                >
                    <GoalCard
                        goal={goal}
                        onClick={() => onGoalClick(goal)}
                    />
                </motion.div>
            ))}

            {isEmpty && (
                <motion.div
                    className="col-span-1 md:col-span-2 lg:col-span-3 text-center py-12 text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 border border-gray-100 dark:border-gray-700"
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{
                        opacity: 1,
                        scale: 1,
                        transition: { delay: 0.2, duration: 0.5 }
                    }}
                >
                    {t('goals.emptyState')}
                </motion.div>
            )}
        </motion.div>
    );
};

export default GoalsGrid;